import React from "react";
import {DaToolbar, DaToolbarButton} from "./Toolbar.styles";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import {IChildGridToolbarProps} from "./types";

export const ChildGridToolbar: React.FC<IChildGridToolbarProps<any>> = (
    {
        showAddButton=true,
        showEditButton=true,
        showDeleteButton=true,
        showResetButton=true,
        onClickAdd = undefined,
        onClickEdit = undefined,
        onClickDelete = undefined,
        onClickReset = undefined,
        disabledAdd = false,
        disabledEdit = false,
        disabledDelete = false,
        disabledReset = false,
        addButtonText = "Add",
    } : IChildGridToolbarProps<any>
) => {
    return (
        <DaToolbar variant="dense">
            <Box sx={{flexGrow: 1,}}>
                {showAddButton &&
                    <DaToolbarButton
                        // startIcon={<AddIcon />}
                        onClick={onClickAdd}
                        disabled={disabledAdd || !onClickAdd}
                    >
                        {addButtonText}
                    </DaToolbarButton>
                }
                {showEditButton &&
                    <DaToolbarButton
                        startIcon={<EditIcon />}
                        onClick={onClickEdit}
                        disabled={disabledEdit || !onClickEdit}
                    >
                        Edit
                    </DaToolbarButton>
                }
                {showDeleteButton &&
                    <DaToolbarButton
                        startIcon={<DeleteIcon />}
                        onClick={onClickDelete}
                        disabled={disabledDelete || !onClickDelete}
                    >
                        Delete
                    </DaToolbarButton>
                }
                {showResetButton &&
                    <DaToolbarButton
                        startIcon={<RestartAltIcon />}
                        onClick={onClickReset}
                        disabled={disabledReset || !onClickReset}
                    >
                        Reset
                    </DaToolbarButton>
                }
            </Box>
        </DaToolbar>
    )
}
